import {Checkbox} from "@chakra-ui/react";
import {ChangeEvent} from "react";

type Props = {
    name: string,
    defaultValue: boolean,
    onChange: (checked: boolean) => void,
    children: any
    disabled?: boolean
}

const ManagedCheckBox = ({name, onChange, defaultValue, children, disabled}: Props) => {
    return <Checkbox
        gridColumn={"1 / span 2"}
        onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.checked)}
        value={name}
        isChecked={defaultValue}
        isDisabled={disabled}
    >
        {children}
    </Checkbox>
}

export default ManagedCheckBox;
